import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type Channel } from "../api";

export default function Dashboard() {
  const [channels, setChannels] = useState<Channel[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState("");
  const [secret, setSecret] = useState("");
  const [busy, setBusy] = useState(false);

  async function load() {
    try {
      const { channels } = await api.listChannels();
      setChannels(channels);
    } catch (e: any) {
      setErr(e.message);
    }
  }

  useEffect(() => { load(); }, []);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await api.createChannel(name.trim(), secret.trim());
      setName(""); setSecret(""); setShowForm(false);
      await load();
    } catch (e: any) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  }

  async function remove(id: string) {
    if (!confirm("確定要刪除這個 Channel？所有 webhook 與紀錄都會一起刪除。")) return;
    try {
      await api.deleteChannel(id);
      await load();
    } catch (e: any) {
      setErr(e.message);
    }
  }

  return (
    <div className="container">
      <div className="header-row">
        <div>
          <h1>我的 Channel</h1>
          <div className="muted">每一個 Channel 對應一個 LINE 官方帳號，可以新增多組下游 webhook。</div>
        </div>
        {!showForm && <button className="primary" onClick={() => setShowForm(true)}>+ 新增 Channel</button>}
      </div>

      {err && <div className="error">{err}</div>}

      {showForm && (
        <form className="card" onSubmit={create}>
          <h2>新增 Channel</h2>
          <div className="hint">
            請到 LINE Developers → 你的 Provider → Channel → Basic settings，複製 <b>Channel secret</b> 貼上。建立後會生成專屬接收網址，請把它貼回 LINE 後台的 <b>Webhook URL</b>。
          </div>
          <div className="field">
            <label>Channel 名稱（只是你自己識別用）</label>
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="例：我的官方帳號" required />
          </div>
          <div className="field">
            <label>LINE Channel Secret</label>
            <input value={secret} onChange={(e) => setSecret(e.target.value)} placeholder="從 LINE Developers 複製" required />
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="primary" type="submit" disabled={busy}>{busy ? "建立中…" : "建立"}</button>
            <button type="button" className="ghost" onClick={() => { setShowForm(false); setName(""); setSecret(""); }}>取消</button>
          </div>
        </form>
      )}

      <div style={{ marginTop: 20 }}>
        {channels === null ? (
          <div className="empty"><span className="spinner" /> 載入中…</div>
        ) : channels.length === 0 ? (
          <div className="card empty">尚無 Channel，點右上角新增一個開始使用</div>
        ) : (
          <div className="list">
            {channels.map((ch) => (
              <div className="row" key={ch.id}>
                <div className="meta">
                  <Link to={`/channels/${ch.id}`} className="name" style={{ color: "inherit" }}>{ch.name}</Link>
                  <span className="sub">ingest slug: {ch.ingest_slug}</span>
                </div>
                <div className="actions">
                  <Link to={`/channels/${ch.id}`}><button>管理</button></Link>
                  <button className="danger" onClick={() => remove(ch.id)}>刪除</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
